module.exports = __webpack_public_path__ + "fadeIn.gif";